import { getTenant, getUserName } from '../helpers';

export const stripeBilling = async (data, callback) => {
  /*api.iblwebstripe.postToStripe(data, function (url) {
    callback(url);
  });*/
  const tenant = getTenant();
  const username= getUserName()
  const token = localStorage.getItem('axd_token');
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/service/orgs/${tenant}/users/${username}/stripe/customer-portal/`;
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + token,
    },
  })
    .then((resp) => {
      resp
        .json()
        .then((data) => {
          if (data?.url) {
            callback(data.url);
          }
        })
        .catch((err) => {
          //
        });
    })
    .catch((err) => {
      //
    });
};